import "core-js/modules/es.regexp.exec.js";
export function findWithRegex(regex, contentBlock, callback) {
  var text = contentBlock.getText();
  var matchArr;
  var start;
  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index;
    callback(start, start + matchArr[0].length);
  }
}